import '@boltenergy-be/design-system/dist/assets/foundations.css'
import { Provider } from 'react-redux'
import { persistor, store } from 'store'
import GeneralErrorHandler from 'components/GeneralErrorHandler/GeneralErrorHandler.tsx'
import Router from 'router/Router.tsx'
import { PersistGate } from 'redux-persist/integration/react'

const Root = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <GeneralErrorHandler>
        <Router />
      </GeneralErrorHandler>
    </PersistGate>
  </Provider>
)

export default Root
